import { css } from '@/styled-system/css';

export const comboboxChipsOverflowStyles = css.raw({
  color: 'text.neutral',
  textStyle: 'body',
  marginInlineEnd: 'tighter',
});
